// NEW_FILE_JUSTIFIED: extracted messaging page wrappers from PageWrappers.tsx to stay under 300-line file limit
import { AppLayoutMemo } from '@/components/layout';
import { MessagesPage } from '@/pages/MessagesPage';
import { GmailPage } from '@/pages/GmailPage';
import { UnifiedInboxPage } from '@/pages/UnifiedInboxPage';
import { WhatsAppPage } from '@/pages/WhatsAppPage';

export function TelegramPageWrapper() {
  return (
    <AppLayoutMemo>
      <MessagesPage />
    </AppLayoutMemo>
  );
}

export function UnifiedInboxPageWrapper() {
  return (
    <AppLayoutMemo>
      <UnifiedInboxPage />
    </AppLayoutMemo>
  );
}

export function GmailPageWrapper() {
  return (
    <AppLayoutMemo>
      <GmailPage />
    </AppLayoutMemo>
  );
}

export function WhatsAppPageWrapper() {
  return (
    <AppLayoutMemo>
      <WhatsAppPage />
    </AppLayoutMemo>
  );
}
